import { Injectable, signal } from '@angular/core';
import type { CompilableQuestion } from '../../services/compiling/apply-compiled-answer';

@Injectable()
export class CompilingDashboardService {
  readonly sectionToFocus = signal<string | undefined>(undefined);
  readonly subSectionToFocus = signal<string | undefined>(undefined);

  /**
   * A question to scroll to, wherever it lives. Set it and the dashboard walks
   * the way there — the right tab, the right section page, then the subsection
   * focus the two signals above already drive.
   *
   * It carries the whole question rather than an id because the callers (the
   * bulk-compile report) already hold its `sectionId`/`subSectionId` from the
   * structure walk, so nothing has to re-derive them.
   */
  readonly questionToFocus = signal<CompilableQuestion | undefined>(undefined);

  focusQuestion(question: CompilableQuestion): void {
    this.questionToFocus.set(question);
  }
}
